import { TradingDocument } from "api/trading-documents/models";
import { RightPanelTableRow } from "components/utils/drawer";
import { currencyConvertSectionListConfig } from "pages/tradingDocuments/shared/utils/panelTablesConfig";
import { dateFns } from "utilities";
import { CreateCorrectionValues } from "../../CreateCorrectionManuallyModal";
import { AmountPerVatRate } from "../AmountPerVatRate";

interface Props {
  currencyConvert: TradingDocument["amountSummaryPerVatRateCurrencyConvert"][number];
  values: CreateCorrectionValues;
}

export const CurrencyConvertionPerVatRate = ({ currencyConvert, values }: Props) => {
  return (
    <RightPanelTableRow grid={currencyConvertSectionListConfig.grid}>
      <div>
        <div className="d-flex align-items-center gap-1">
          {currencyConvert.exchangeRate ? (
            <>
              <strong className="body-14 fw-800">
                {String(currencyConvert.exchangeRate).replace(/\./g, ",")}&nbsp;
              </strong>
              <span className="body-12 text-black-6">PLN</span>
            </>
          ) : (
            "--"
          )}
        </div>
      </div>
      <div>
        {currencyConvert.exchangeRateDate ? (
          <div>{dateFns.format(new Date(currencyConvert.exchangeRateDate), "dd.MM.yyyy")}</div>
        ) : (
          "--"
        )}
      </div>
      <div className="d-flex align-items-center justify-content-end text-grey-35">w tym:</div>
      {currencyConvert.vatRate !== undefined && currencyConvert.vatRate !== null ? (
        <div className="fw-700">{currencyConvert.vatRate}%</div>
      ) : (
        "--"
      )}
      <div className="d-flex align-items-center justify-content-end gap-1">
        {currencyConvert.vatRate !== undefined &&
        currencyConvert.vatRate !== null &&
        currencyConvert.exchangeRate ? (
          <AmountPerVatRate
            conversionRate={currencyConvert.exchangeRate}
            fieldName="amountWithoutTax"
            vatRate={currencyConvert.vatRate}
            values={values}
          />
        ) : (
          "--"
        )}
      </div>
      <div className="d-flex align-items-center justify-content-end gap-1">
        {currencyConvert.vatRate !== undefined &&
        currencyConvert.vatRate !== null &&
        currencyConvert.exchangeRate ? (
          <AmountPerVatRate
            conversionRate={currencyConvert.exchangeRate}
            fieldName="taxAmountBeforeRounding"
            vatRate={currencyConvert.vatRate}
            values={values}
          />
        ) : (
          "--"
        )}
      </div>
      <div className="d-flex align-items-center justify-content-end gap-1">
        {currencyConvert.vatRate !== undefined &&
        currencyConvert.vatRate !== null &&
        currencyConvert.exchangeRate ? (
          <AmountPerVatRate
            conversionRate={currencyConvert.exchangeRate}
            fieldName="amountWithTax"
            vatRate={currencyConvert.vatRate}
            values={values}
          />
        ) : (
          "--"
        )}
      </div>
    </RightPanelTableRow>
  );
};
